import { Loader2 } from "lucide-react";

import DashboardLayout from "@/components/layout/DashboardLayout";
import Typography from "@/components/ui/typography";
import { MarketplaceSection } from "@/features/marketplace/components";
import { useCurrentUser } from "@/hooks/useCurrentUser";

const FounderPublicProfilePage = () => {
  const { isLoading } = useCurrentUser();

  if (isLoading) {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center min-h-[400px]">
          <Loader2 className="h-8 w-8 animate-spin" />
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div className="flex items-start">
          <div className="space-y-1">
            <Typography size="h2" className="text-[#1e1e24]">
              Profile
            </Typography>
            <Typography size="b2" className="text-[#767677]">
              Manage your public profile on the Stack marketplace.
            </Typography>
          </div>
        </div>

        <div className="grid gap-6">
          <MarketplaceSection />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default FounderPublicProfilePage;
